"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentModel = void 0;
const BaseModel_1 = require("./base/BaseModel");
const _ = require("lodash");
class DeploymentModel extends BaseModel_1.BaseModel {
    constructor(options) {
        super(options);
        this.org_id = null;
    }
    setOrg(id) {
        this.org_id = id;
    }
    get model() {
        return this.options.model;
    }
    get id() {
        return this.model.id;
    }
    get app() {
        return this.options.banks.appsBank.models[this.model.app_id];
    }
    getApp() {
        return this.options.banks.appsBank.resolve(this.model.app_id);
    }
    async getParents() {
        return [await this.getApp()];
    }
    async getResourceSelector() {
        return {
            id: this.id,
            parents: await this.getParentResourceSelectors(),
            model: 'deployment',
            labels: _.pickBy({
                region: this.model.region_code,
                environment: this.model.region_environment,
                managed: this.model.managed ? 'true' : 'false'
            })
        };
    }
    async getComparativeResource() {
        return {
            scope: this.org_id,
            selector: await this.getResourceSelector()
        };
    }
    async delete() {
        var _a;
        await this.options.clients.provisionDeployServiceClient().deleteDeployment({
            deployment_id: this.id
        });
        await ((_a = this.app) === null || _a === void 0 ? void 0 : _a.loadDeployments());
    }
}
exports.DeploymentModel = DeploymentModel;
